import React from 'react';
import { motion } from 'framer-motion';
import { Period } from '../types';
interface PeriodToggleProps {
  value: Period;
  onChange: (period: Period) => void;
}
export function PeriodToggle({
  value,
  onChange
}: PeriodToggleProps) {
  const periods: Period[] = ['day', 'month', 'year'];
  return <div className="flex bg-stone-800 p-1 rounded-2xl w-full max-w-xs mx-auto" data-id="element-62">
      {periods.map(period => {
      const isActive = value === period;
      return <button key={period} onClick={() => onChange(period)} className={`relative flex-1 py-2 text-sm font-medium capitalize rounded-xl transition-colors z-0 ${isActive ? 'text-stone-900' : 'text-stone-400 hover:text-stone-200'}`} data-id="element-63">
            {isActive && <motion.div layoutId="period-pill" className="absolute inset-0 bg-stone-200 rounded-xl -z-10 shadow-sm" transition={{
          type: 'spring',
          stiffness: 400,
          damping: 30
        }} data-id="element-64" />}
            {period}
          </button>;
    })}
    </div>;
}